module.exports = __webpack_public_path__ + "static/media/icon-dashboard-empty.7d6c17b5.png";